import { type UseQueryResult, useQuery } from 'react-query';
import { GrantService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetGrantVestingTemplateList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const grantVestingTemplateList = useQuery(
    ['getGrantVestingTemplateList'],
    async () => {
      return await handleRequest(GrantService.getApiAwardApiAppGrantVestingSchedule());
      //   }
      //   return await handleRequest(GrantService.getApiAwardApiAppGrantPlanTypes());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return grantVestingTemplateList;
};

export default useGetGrantVestingTemplateList;
